'use strict';

/**
 *
 * @name: memberAnalytics
 *
 */

function MemberAnalyticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function become() {

    var properties = {
      eventAction: 'Become a contributor',
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Contributor', properties);
  }

  function follow(user, label) {

    var eventActionLabel, identifier;

    if (user.roles.indexOf('member') > -1) {

      eventActionLabel = 'Regular member : ';
      identifier = user.id;
    }

    if (user.roles.indexOf('contributor') > -1) {

      eventActionLabel = 'Contributor : ';
      identifier = user.id;
    }

    if (user.roles.indexOf('brand') > -1) {

      eventActionLabel = 'Brand: ';
      identifier = user.displayName;
    }

    if (user.roles.indexOf('contributor') === -1) {

      label = $location.path();
    }

    if (user.roles.indexOf('contributor') === -1 && user.roles.indexOf('brand') === -1) {

      return false;
    }

    var properties = {
      eventAction: eventActionLabel + identifier,
      eventPoints: 0,
      attributes: {
        label: label
      }
    };

    return $analytics.eventTrack('Follow', properties);
  }

  function loved(user, post) {

    if (user.roles.indexOf('contributor') > -1) {

      var properties = {
        eventAction: 'Loved',
        eventPoints: 0,
        attributes: {
          label: 'Contributor loved | ' + post.translations[$rootScope.lang].title
        }
      };

      return $analytics.eventTrack('Contributor', properties);
    }
  }

  function unfollow(user, label) {

    var eventActionLabel, identifier;

    if (user.roles.indexOf('contributor') > -1) {

      eventActionLabel = 'Contributor : ';
      identifier = user.id;
    }

    if (user.roles.indexOf('brand') > -1) {

      eventActionLabel = 'Brand: ';
      identifier = user.displayName;
      label = $location.path();
    }

    if (user.roles.indexOf('contributor') === -1 && user.roles.indexOf('brand')) {

      label = $location.path();
      return true;
    }

    var properties = {
      eventAction: eventActionLabel + identifier,
      eventPoints: 0,
      attributes: {
        label: label
      }
    };

    return $analytics.eventTrack('Unfollow', properties);
  }

  function videoAM(post) {

    var properties = {
      eventAction: 'Customer account | loved | loved',
      attributes: {
        label: post.id + ' | ' + post.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  return {
    become: become,
    follow: follow,
    loved: loved,
    unfollow: unfollow,
    videoAM: videoAM,
  };
}

export default MemberAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/member/member-analytics.factory.js